import {
  QueryClient,
  UseQueryOptions,
  UseMutationOptions,
  DefaultOptions,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { isForErrorBoundary, baseErrorHandler } from './util'

const defaultQueryOptions: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    cacheTime: 0,
    useErrorBoundary: (error) => isForErrorBoundary(error),
    onError: (error) => baseErrorHandler(error),
  },
  mutations: {
    useErrorBoundary: (error) => isForErrorBoundary(error),
    onError: (error) => baseErrorHandler(error),
  },
}

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
})

export type QueryConfig<
  FetcherFnType extends (...args: any) => T,
  T = any
> = Omit<
  UseQueryOptions<Awaited<ReturnType<FetcherFnType>>, AxiosError<any>>,
  'initialData'
>

export type MutationConfig<
  FetcherFnType extends (...args: any) => T,
  T = any
> = UseMutationOptions<
  Awaited<ReturnType<FetcherFnType>>,
  AxiosError<any>,
  Parameters<FetcherFnType>[0]
>
